var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChatDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.645,
    height: 20.382,
    viewBox: "0 0 21.645 20.382",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New_chat_icon",
    "data-name": "New chat icon",
    transform: "translate(-43.843 -266.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2074",
    "data-name": "Group 2074",
    transform: "translate(51.678 271.959)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_519",
    "data-name": "Line 519",
    y2: 6.259,
    transform: "translate(2.987 0)",
    fill: "none",
    stroke: "#072531",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_520",
    "data-name": "Line 520",
    x1: 5.975,
    transform: "translate(0 3.13)",
    fill: "none",
    stroke: "#072531",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2959",
    "data-name": "Path 2959",
    d: "M15.309,15.618H9L4.886,18.632l-.05-3.014A4.586,4.586,0,0,1,.25,11.032V4.838A4.587,4.587,0,0,1,4.836.25H15.309a4.587,4.587,0,0,1,4.586,4.588v6.193A4.586,4.586,0,0,1,15.309,15.618Z",
    transform: "translate(44.593 267.209)",
    fill: "none",
    stroke: "#072531",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChatDark);
export default __webpack_public_path__ + "static/media/NewChat-Dark.5d21feb65f66dbbc210c8acce0b6c95d.svg";
export { ForwardRef as ReactComponent };